<script>
    import { createEventDispatcher } from "svelte"

    console.log("Initializing ClearButton")

    const dispatch = createEventDispatcher()

    console.log("ClearButton initialized")
</script>

<button on:click={() => dispatch('clear', ['date', 'month', 'year'])}>Clear</button>
